import 'css-chunksrc/client/pages/workloadPage/table/row/styles.scss';export default {
  "resourceRow": "_resourceRow_1n3e1_1",
  "withMonthRow": "_withMonthRow_1n3e1_9",
  "resourceCell": "_resourceCell_1n3e1_13",
  "clickable": "_clickable_1n3e1_29",
  "chevronBox": "_chevronBox_1n3e1_33",
  "identityGroup": "_identityGroup_1n3e1_41",
  "avatar": "_avatar_1n3e1_50",
  "identity": "_identity_1n3e1_41",
  "name": "_name_1n3e1_60",
  "cell": "_cell_1n3e1_69",
  "overCapacity": "_overCapacity_1n3e1_83"
};